// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  app: 'Topdepo',
  androidAppId: 'gg.omni.topdepo',
  iosAppId: '',
  baseUrl: 'https://staging-panel.topdepo.omni.gg',
  currency: 'IDR',
  locale: 'id-ID',
  googleAuth: {
    clientId: '260599924679-kcgt99ud9bd2bpebkj6i54g1t8g51h1s.apps.googleusercontent.com',
  },
  googleMaps: {
    apiKey: 'AIzaSyBghYYC6C0coHL_CHZFeOH0k0L3WNwwA0M',
  },
  oneSignal: {
    appId: '2a6dbfc7-8b28-4bda-b9c0-75024fcd7725',
  },
  midtrans: {
    snapUrl: 'https://app.sandbox.midtrans.com/snap/snap.js',
    clientKey: 'SB-Mid-client-wVoAYyERTygeSVmt',
  },
  firebaseConfig: {
    apiKey: 'AIzaSyA4UWWNJ4L0T6IWpKVvaCr2fPfI-Gjzkd4',
    authDomain: 'topdepo-8193a.firebaseapp.com',
    projectId: 'topdepo-8193a',
    storageBucket: 'topdepo-8193a.appspot.com',
    messagingSenderId: '444306200771',
    appId: '1:444306200771:web:87ce5ff643858c6c20aa76',
    measurementId: 'G-32ZJMV8QQM',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
